// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/normalize.css'
import axios from './api'
import store from './store'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default global options } */)



Vue.prototype.$$$api = axios

Vue.config.productionTip = false



router.beforeEach((to, from, next) => {
    if (store.state.indexData) {
        next()
        return
    }
    axios.homeData().then(res => {
        store.commit('setIndexData', res.data.data);
        next()
    })
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js